import { render, staticRenderFns } from "./ProposalViewer.vue?vue&type=template&id=11b064a5&"
import script from "./ProposalViewer.vue?vue&type=script&lang=js&"
export * from "./ProposalViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProposalViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b064a5')) {
      api.createRecord('11b064a5', component.options)
    } else {
      api.reload('11b064a5', component.options)
    }
    module.hot.accept("./ProposalViewer.vue?vue&type=template&id=11b064a5&", function () {
      api.rerender('11b064a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/viewer/ProposalViewer.vue"
export default component.exports